var e={start:"flex-start",center:"center",end:"flex-end"};export{e as SUPPORTED_ALIGNMENTS};
//# sourceMappingURL=FGMediaObject.shared.js.map
